import { useNavigate, useParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon } from '../../../config/variables';
import { navigateRoute, hasPermission } from '../../../utils/HelperFunctions';
import DeleteButton from '../../../components/buttons/DeleteButton';

const SpecificationsTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: any) => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  const hasEditPermission = hasPermission(['specs.edit'])

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map((header: any, index: number) => (
          <span className={`head ${header.customClass}`} key={index}>
            {header.label}
          </span>
        ))}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item: any, index: number) => (
              <div
                className={`item ${hasEditPermission && 'clickable'} has_logo vehicle_makes`}
                key={index}
                onClick={(e) => {
                  hasEditPermission && navigateRoute(e, `/specification-groups/specifications/${slug}/create-specification/${item.id}`, navigate);
                }}
              >
                <div className="column">{item?.name?.en || '-'}</div>
                <div className="column">{item?.name?.ar || '-'}</div>
                <div className="column capitalize">{item?.type || '-'}</div>
                {hasEditPermission && (
                  <div className="column actions actions_col">
                    <div
                      className="action_btn edit"
                      onClick={(e) => {
                        navigateRoute(e, `/specification-groups/specifications/${slug}/create-specification/${item.id}`, navigate);
                      }}
                    >
                      {editIcon}
                    </div>
                    <DeleteButton deleteRoute={`/admin/specs`} queryKey="specs" id={item.id} />
                  </div>
                )}
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default SpecificationsTableContainer;
